import { camelizeKeys } from 'humps';

import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.COMPLAINT_SHOW_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.COMPLAINT_SHOW_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, camelizeKeys(response.data));
  } else {
    onFailed(dispatch, response.data);
  }
};

export const complaintShow = (id) => {
  return async (dispatch) => {
    dispatch({ type: CONST.COMPLAINT_SHOW_ERROR });

    axios.get(`/tickets/${id}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
